import { render, staticRenderFns } from "./CheckTab.vue?vue&type=template&id=88fa4156&scoped=true"
import script from "./CheckTab.vue?vue&type=script&lang=js"
export * from "./CheckTab.vue?vue&type=script&lang=js"
import style0 from "./CheckTab.vue?vue&type=style&index=0&id=88fa4156&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fa4156",
  null
  
)

export default component.exports